import { get } from '@web3/base-utils';

import {
  EntityListResp,
  HackerAddressListResp,
  BridgeActorsResp,
  MixerResp,
  CollaboratorsListResp,
} from '@/types/home';

// mokc数据
function mockResolve<T>(data: T, ms = 0): Promise<T> {
  return new Promise((_resolve, _reject) => {
    window.setTimeout(() => {
      _resolve(data);
    }, ms);
  });
}

// 机构列表
export const getEntityList = () => {
  return get<EntityListResp[]>('/spot/api/web3/content/hack/entityList');
};

// 获取黑客地址列表
export const getHackerAddressList = (params: {
  pageNo: number;
  pageSize: number;
}) => {
  return get<HackerAddressListResp>(
    '/spot/api/web3/content/hack/hackerAddressList',
    params
  );
};

// 获取总统计数据
export type GetHackTotalStatsRes = {
  totalBounty: string;
  paidBounty: string;
  bountyHunters: number;
  totalHackedAmount: string;
  trackingAmount: string;
  awaitingResponseAmount: string;
  frozenAmount: string;
  lossAmount: string;
};
export const getHackTotalStats = () => {
  return get<GetHackTotalStatsRes>('/spot/api/web3/content/hack/totalStats');
};

// 获取report列表
type GetReportListRes = {
  pageInfo: {
    totalPage: number;
    totalNum: number;
    pageNo: number;
    pageSize: number;
  };
  dataList: {
    reportTime: number;
    reporterName: string;
    reporterAddress: string;
    fundAmount: string;
    entiryResponseTime: number;
    entityUserAddress: string;
    estBounty: string;
    /**
     * 0: No Response
     * 1: Blocked
     * 2: Reject Support
     */
    status: 0 | 1 | 2;
  }[];
};
export const getReportList = ({
  page = 0,
  pageSize = 6,
  entityName = '',
}: {
  page?: number;
  pageSize?: number;
  entityName?: string;
}) => {
  return get<GetReportListRes>('/spot/api/web3/content/hack/verifiedReport', {
    page,
    pageSize,
    entityName,
  });
};

/**
 * 排名接口
 * https://uponly.larksuite.com/wiki/JXwXwZ5DsipYjRkqdvbu4Axxscg
 */
type BountyData = {
  /** 排名 */
  ranking: number;
  /** 提交报告者名称 */
  reporterName: string;
  /** 上传提交线索连接钱包地址 */
  reportAddress: string;
  /** 通过的报告数量 */
  verifiedReportNum: number;
  /** 提交资金总额 */
  reportFunds: string;
  /** 拦截的资金总额 */
  blockFunds: string;
  /** 预估奖金 */
  estBounty: string;
};

type PageInfo = {
  totalPage: string;
  totalNum: number;
  pageNo: number;
  pageSize: number;
};

type GetBountyListParams = {
  page: number;
  pageSize: number;
};

export const getBountyListApi = (params: GetBountyListParams) => {
  return get<{ pageInfo: PageInfo; dataList: BountyData[] }>(
    '/spot/api/web3/content/hack/contributors',
    params
  );
};

export interface HackerAddressTopListResp {
  totalAmount: string;
  chainAssetList: ChainAsset[];
}

interface ChainAsset {
  chainName: string;
  totalAmount: string;
  addressCount: number;
  amountRatio: string;
  topAddressList: HackAddress[];
  othersTotalAmount: string;
}

interface HackAddress {
  address: string;
  holdingValue: string;
  viewUrl: string;
}

export enum ChainType {
  BTC = 'BTC',
  ETH = 'ETH',
  BNB = 'BNB Smart Chain',
  ARB = 'Arbitrum',
  SOL = 'SOLANA',
  TRON = 'TRON',
}

export const getHackerAddressTopList = () => {
  return get<HackerAddressTopListResp>(
    '/spot/api/web3/content/hack/hackerAddressTopList'
  );
};

// 获取 bride actors
export const getBridgeActors = (params: { page: number; pageSize: number }) => {
  return get<BridgeActorsResp>(
    '/spot/api/web3/content/hack/bridgeActors',
    params
  );
};

// 获取 mixer 数据
export const getMixerData = (params: { page: number; pageSize: number }) => {
  return get<MixerResp>('/spot/api/web3/content/hack/mixerList', params);
};

export const getCollaboratorList = (params: {
  page: number;
  pageSize: number;
}) => {
  return get<CollaboratorsListResp>(
    '/spot/api/web3/content/hack/collaborators',
    params
  );
};
